import { Permission } from './models/Permissions';

export interface PagingRequest {
  limit: number;
  cursor: string | null;
}

export enum CloudProvider {
  AZURE = 'Azure',
  AWS = 'AWS',
  AWS_OCI = 'AWS_OCI',
}

export type TaniumInstance = {
  id: string;
  licenseId: string;
  createdAt: string;
  displayName: string;
  cloudProvider?: CloudProvider;
};

export interface DomainsResponse {
  data: Domain[];
  nextPageCursor: string | null;
  totalCount: number;
}

export enum DomainStatus {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  CONFLICT = 'CONFLICT',
}

export type Domain = {
  id: string;
  tenantId: string;
  domainName: string;
  dnsRecordValue: string;
  verificationStatus: DomainStatus;
  domainUsages: string[];
};
export interface OidcMetadataRequest {
  email?: string;
  username?: string;
}
export interface OidcMetadataResponse {
  oidcMetadataUrl: string;
  tokenEndpoint: string;
  authEndpoint: string;
  clientId: string;
}

export enum SessionKeys {
  AmpToken = 'amp_token',
  AmpIdToken = 'amp_id_token',
  AmpRefreshToken = 'amp_refresh_token',
  AmpTokenExpiration = 'amp_token_expiration',
  Verifier = 'verifier',
  Auth = 'auth',
  OidcMeta = 'oidc_meta',
}

export interface PermissionsResponse {
  permissions: Permission[];
}
